import React from "react";
import { toast } from "sonner";
import { FileText, HelpCircle, Image, Ticket, ShieldAlert, Save } from "lucide-react";

const SECTIONS = [
  { icon: FileText, title: "Homepage Content", desc: "Edit headline, tagline, dan copy hero." },
  { icon: Ticket, title: "Ticket Information", desc: "Atur harga, benefit, dan syarat tiket." },
  { icon: HelpCircle, title: "FAQ", desc: "Tambah / ubah pertanyaan yang sering diajukan." },
  { icon: Image, title: "Sponsors & Partners", desc: "Kelola logo sponsor dan kategori partner." },
  { icon: ShieldAlert, title: "Terms & Conditions", desc: "Perbarui syarat & ketentuan event." },
];

export default function AdminSettings() {
  return (
    <div>
      <h1 className="font-display text-2xl sm:text-3xl text-slate-800">Settings & Content</h1>
      <p className="text-slate-500 font-semibold">Kelola konten website tanpa hardcode. (Prototype CMS)</p>

      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {SECTIONS.map((s) => (
          <div key={s.title} className="bg-white rounded-xl border border-slate-200 shadow-sm p-5" data-testid={`setting-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="w-11 h-11 rounded-xl bg-sky/25 text-sea-deep flex items-center justify-center">
              <s.icon className="w-5 h-5" />
            </div>
            <h3 className="mt-3 font-display text-lg text-slate-800">{s.title}</h3>
            <p className="text-sm font-semibold text-slate-500">{s.desc}</p>
            <button
              onClick={() => toast.info("Editor CMS akan tersedia pada versi berikutnya.")}
              className="mt-4 flex items-center gap-2 text-sm font-semibold text-sea hover:underline"
            >
              <Save className="w-4 h-4" /> Kelola
            </button>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-sunny/15 border border-sunny/40 rounded-xl p-4 text-sm font-semibold text-slate-600">
        Catatan: Ini versi <b>mockup UI</b>. Perubahan konten & aktivitas belum tersambung ke database.
      </div>
    </div>
  );
}
